import React, { memo } from "react";
import { StyleTag } from "seed/helpers"

const SolutionIcon = memo(function SolutionIconComponent({
  className = "",
  style,
}) {
  return (
    <svg viewBox="0 0 120 120"
      style={style} className={className}>
      <StyleTag content={`
        .solution-icon-0{fill:none;stroke:#2080e5a0;}
        .solution-icon-1{fill:#2080e5;}
        .solution-icon-2{fill:#2080e5;}
      `} />
      <path class="solution-icon-0 fill-none stroke-gray-400" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M5.9,88.9c-5.3-3-5.3-8,0-11l44.4-25.7c5.3-3,13.8-3,19.1,0l44.5,25.7c5.3,3,5.3,8,0,11l-44.4,25.7
	c-5.3,3-13.8,3-19.1,0L5.9,88.9z"/>
      <path class="solution-icon-1 fill-gray-400" opacity=".5" d="M4.7,65.6c-5.4-3.1-5.4-8.2,0-11.3l45.5-26.2c5.4-3.1,14.2-3.1,19.5,0l45.5,26.2c5.4,3.1,5.4,8.2,0,11.3
	L69.8,91.8c-5.4,3.1-14.2,3.1-19.5,0L4.7,65.6z"/>
      <path class="solution-icon-2 fill-primary" d="M4.7,43c-5.4-3.1-5.4-8.2,0-11.3L50.2,5.5c5.4-3.1,14.2-3.1,19.5,0l45.5,26.2c5.4,3.1,5.4,8.2,0,11.3L69.8,69.3
	c-5.4,3.1-14.2,3.1-19.5,0L4.7,43z"/>
    </svg>)
});


export default SolutionIcon;